<!-- Search bar -->
<form class="business-domains-search-form" [formGroup]="businessDomainsSearchForm">
    <mat-form-field class="flex-grow-1" subscriptSizing="dynamic">
        <input matInput type="text" placeholder="Search for a Business Domain" formControlName="search" />
    </mat-form-field>

    <mat-checkbox formControlName="returnAll" [disabled]="loadingResults()">Return all</mat-checkbox>
</form>

<div class="my-3">
    <mat-progress-spinner
        *ngIf="loadingResults()"
        mode="indeterminate"
        diameter="30"
        color="primary"
        style="margin: 20px auto; display: block"
    >
    </mat-progress-spinner>
</div>

@if (businessDomains$ | async; as domains) {
    <table mat-table [dataSource]="domains" class="mat-elevation-z2" style="width: 100%">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let domain">{{ domain.name || 'N/A' }}</td>
        </ng-container>

        <!-- State Column -->
        <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef>State</th>
            <td mat-cell *matCellDef="let domain">{{ domain.state || 'N/A' }}</td>
        </ng-container>

        <!-- Confidentiality Column -->
        <ng-container matColumnDef="confidentiality">
            <th mat-header-cell *matHeaderCellDef>Confidentiality</th>
            <td mat-cell *matCellDef="let domain">{{ domain.confidentiality || 'N/A' }}</td>
        </ng-container>

        <!-- Roles Column -->
        <ng-container matColumnDef="roles">
            <th mat-header-cell *matHeaderCellDef>Roles</th>
            <td mat-cell *matCellDef="let domain">
                @if (domain.roles) {
                    <ul>
                        @for (roleName of getRoles(domain); track roleName) {
                            <li>
                                <a
                                    [href]="
                                        'https://portal.azure.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Owners/groupId/' +
                                        domain.roles[roleName].groupId
                                    "
                                    target="_blank"
                                >
                                    {{ roleName }}
                                </a>
                            </li>
                        }
                    </ul>
                } @else {
                    <span>No roles</span>
                }
            </td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let domain">
                @if (domain.userRoles !== 'None') {
                    <button mat-button class="detailButtonClass" [routerLink]="['/business-domain-details', domain.id]">
                        Details
                    </button>
                }
            </td>
        </ng-container>

        <!-- Header and Row Declarations -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
}
